/**
 * Thumbnail mapping organized by tab, then by menu item name.
 * Maps specific menu items to their thumbnail image URLs (48x48px).
 *
 * Structure:
 * {
 *   [TabName]: {
 *     [MenuItemName]: 'image-url'
 *   }
 * }
 *
 * Helper function to generate src and srcset for different screen densities
 */
const getThumbnailUrls = baseUrl => {
  const formatUrl = (url, width) => {
    const separator = url.includes('?') ? '&' : '?';
    const path = 'https://media.johnlewiscontent.com/i/JohnLewis/';
    return `${path}${url}${separator}fmt=auto&wid=${width}&sm=aspect&aspect=1:1`;
  };

  const src = formatUrl(baseUrl, 48); // 1x for standard displays
  const srcset = [
    `${src} 1x`,
    `${formatUrl(baseUrl, 96)} 2x`, // 2x for Retina displays
    `${formatUrl(baseUrl, 144)} 3x`, // 3x for higher density displays
  ].join(', ');

  return { src, srcset };
};

export const thumbnailMap = {
  Shop: {
    'New In': getThumbnailUrls(
      '2025SPRWRAPPERSTILLLIFESHOT121208ITGproofedRGB'
    ),
    Women: getThumbnailUrls(
      '009386022?scaleFit=poi&poi=0.39142441860465116,0,0.19970930232558137,0.15'
    ),
    Men: getThumbnailUrls('2025_SPR_WRAPPER_MW_SHOT_9_1109'),
    'Home & Garden': getThumbnailUrls(
      '2026_SS26_HOME_SHOT%2030_RUSTIC%20TABLEWARE_1491_ALT?scaleFit=poi&poi=0.31910377358490566,0.5052441056887177,0.3240566037735849,0.21637635298988583'
    ),
    'Furniture & Lights': getThumbnailUrls(
      '2026%20SS26%20HOME%20SHOT%2041%20LAMP%201896%20ITGproofedRGB'
    ),
    Electricals: getThumbnailUrls('113473362alt7'),
    'Baby & Kids': getThumbnailUrls(
      '2026_SPR_WRAPPER_KW_SHOT_6_3133_2_ITGproofedRGB'
    ),
    Beauty: getThumbnailUrls(
      '2025_SPR_WRAPPER_STILL_LIFE_SHOT_19_1304_BACKFOCUS'
    ),
    'Sport & Travel': getThumbnailUrls('Runyourway202425CandiceDamienTrail'),
    Gifts: getThumbnailUrls('1490774-MothersDay-OT-SmallDuplexBanner-1x1'),
    'Sale & Offers': getThumbnailUrls('app-department-offers-hero-190125'),
    'Shop by Room': getThumbnailUrls('ANYDAY_SU21_KITCHEN_17_0030_HERO'),
  },
  Brands: {
    Apple: getThumbnailUrls('iphone17pro-block-090925'),
    CHANEL: getThumbnailUrls('CHANEL-CHANCE-JLP-header-3840x920-09012026'),
    LEGO: getThumbnailUrls('legonewreleasegoldbrandstore'),
    MOTHER: getThumbnailUrls('012917345'),
    'Dowsing & Reynolds': getThumbnailUrls('114393856'),
    Hisense: getThumbnailUrls('114452555'),
    Jellycat: getThumbnailUrls('111074425'),
    Oura: getThumbnailUrls('112562960'),
    'Le Creuset': getThumbnailUrls('112090182'),
    'Anonymous Copenhagen': getThumbnailUrls('010205179'),
    DIOR: getThumbnailUrls('dior-fragrance-category-block-brandhub-200825'),
    Longchamp: getThumbnailUrls('109647232'),
    'John Lewis': getThumbnailUrls('240993170'),
    'J. Lewis': getThumbnailUrls('010000842'),
    'John Lewis ANYDAY': getThumbnailUrls('008892169'),
    Topshop: getThumbnailUrls('013156833'),
    'The Upside': getThumbnailUrls('012278822'),
  },
  Services: {
    "Women's styling": getThumbnailUrls(
      'personal-styling-service-express-service-block-050924'
    ),
    "Men's styling": getThumbnailUrls('1920x1080Tommy2301BannerMW'),
    'Beauty treatments': getThumbnailUrls(
      'our-services-beauty-treatments-block-040924?scaleFit=poi&poi=0.0806049822064057,0.26388910368243995,0.24448398576512456,0.24448398576512456'
    ),
    'All Things Baby': getThumbnailUrls(
      'our-services-all-things-baby-block-40924?scaleFit=poi&poi=0.4934163701067616,0.15356881898493108,0.24448398576512456,0.24448398576512456'
    ),
    'Fitted Kitchens': getThumbnailUrls(
      'fitted-kitchen-service-hiw-block1-290524'
    ),
    'Home Design Service': getThumbnailUrls(
      'our-services-home-services-block-040924'
    ),
    'John Lewis Opticians': getThumbnailUrls('opticians-david-clulow-2-041225'),
    'Payment Plans': getThumbnailUrls('FS24HomeShot110080'),
    'Pay with Klarna': getThumbnailUrls('payment-plans-klarna-logo-101224'),
  },
};
